module.exports = __webpack_public_path__ + "img/consumption.5399674a.png";